module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Termin buchen ro.e4a8276c.svg";